export enum GridApiRoutes {
  metadata = 'metadata',
  gridColumns = 'gridColumns',
  search = 'search',
  columns = 'columns',
  do = 'do',
  gridPreferences = 'gridPreferences',
  multiSearch = 'multiSearch'
}
